import React, { useState, useContext, useEffect } from 'react';
import { Button } from '@mui/material';
import { MapContext } from '../MapContext';
import { LayerContext } from '../LayerContext';
import { addGeoTiffLayer } from "../../common/layer/addGeoTiffLayer";
import ColorMap from './ColorMap';

const FictureControls = ({ layer, layerVisibility, styles }) => {
  const { map } = useContext(MapContext);
  const { dispatch } = useContext(LayerContext);
  const [isMuted, setIsMuted] = useState(false);
  const [colormapModified, setColormapModified] = useState(false);

  const rgbaArrayToHex = (rgba) => {
    return "#" + rgba.map(val => val.toString(16).padStart(2, "0")).join("");
  };

  const isIgnoredColor = (rgba) => {
    const ignoredColors = [
      [0, 0, 0, 255],
      [0, 0, 0, 0]
    ];
    return ignoredColors.some(ignored => JSON.stringify(ignored) === JSON.stringify(rgba));
  };

  const initialColormap = Object.entries(layer.meta?.colormap || {}).reduce((acc, [key, rgba]) => {
    if (!isIgnoredColor(rgba)) {
      acc[key] = rgbaArrayToHex(rgba);
    }
    return acc;
  }, {});

  const [colormap, setColormap] = useState(initialColormap);

  useEffect(() => {
    if (styles?.colormap) {
      const newColormap = JSON.parse(styles.colormap);
      setColormap(newColormap);
      updateLayer(newColormap);
    }
  }, [styles]);

  const handleColorChange = (key, colorHex) => {
    const updatedColormap = {
      ...colormap,
      [key]: colorHex
    };
    setColormap(updatedColormap);
    setColormapModified(true);
  };
  const adjustColormapAlpha = (isMuted) => {
    return Object.entries(colormap).reduce((acc, [key, colorHex]) => {
      // Extract R, G, and B from the color, and set alpha based on isMuted
      const rgb = colorHex.slice(1, 7); // Gets the RRGG and BB parts
      const alpha = isMuted ? "00" : "FF";
      acc[key] = `#${rgb}${alpha}`;
      return acc;
    }, {});
  };


  const handleMuteToggle = () => {
    const muted = !isMuted; // Toggle the mute state
    const updatedColormap = adjustColormapAlpha(muted);
    setIsMuted(muted);
    setColormap(updatedColormap);
    setColormapModified(true);
  };

  const updateLayer = async (newColormap = null) => {
    // get layer order before re-rendering ficure layer
    const mapLayerIds = map?.current?.getStyle()?.layers?.map(l => l.id);
    const currentLayerIndex = mapLayerIds.indexOf(layer.id);
    const beforeLayerId = mapLayerIds[currentLayerIndex + 1];
    dispatch({
      type: 'CHANGE_LAYER',
      payload: await addGeoTiffLayer(
        map.current,
        {
          url: layer.assetUrl,
          colormap: encodeURIComponent(JSON.stringify(newColormap || colormap)),
        },
        'fic',
        layer.id,
        layer.sourceId,
        false
      )
    });
    if (styles?.rasterOpacity) {
      map.current.setPaintProperty(layer.id, 'raster-opacity', styles.rasterOpacity);
    }
    setColormapModified(false);
    // move layer to the correct order
    map?.current?.moveLayer(layer.id, beforeLayerId);
  };

  return (
    <div className="controls-container">
      <div className="header-container">
        <div>Color Map</div>
        <Button
          onClick={handleMuteToggle}
          variant="outlined"
          className="compactButton"
          disabled={!layerVisibility}
        >
          {isMuted ? "Unmute" : "Mute"}
        </Button>
        <Button
          onClick={() => { updateLayer() }}
          variant={colormapModified ? "contained" : "outlined"}
          className="compactButton"
          disabled={!layerVisibility}
        >update</Button>
      </div>
      <ColorMap
        colormap={colormap}
        handleColorChange={handleColorChange}
        isHex={true}
      />
    </div>
  );
}

export default FictureControls;

